import api from '@/plugins/api';
import { checkError, cloneDeep, parseAddressToApp, prepareApiParams } from 'erp-skeleton-library/utils';
import { usersTenants } from '@/plugins/enums';

const template = {
  id: 0,
  type: 3,
  name: null,
  taxId: null,
  tenants: [ { type: usersTenants.TYPE_SUPERVISOR } ],
  phones: [ {} ],
  addresses: [
    {
      address: {
        zipCode: undefined,
        city: undefined,
        state: undefined,
        address: undefined,
        number: undefined,
      },
    },
  ],
};

const state = {
  tableLoading: false,
  allSupervisors: [],
  registerSupervisor: cloneDeep(template),
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
    },
    {
      text: 'CPF',
      align: 'left',
      value: 'taxId',
    },
    {
      text: 'Email',
      align: 'left',
      value: 'email',
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allSupervisors = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    if (!!payload) {
      payload.addresses = parseAddressToApp(payload);
      payload.phones = (payload.phones) ? payload.phones : [ {} ];
      state.registerSupervisor = payload;

    } else {
      state.registerSupervisor = cloneDeep(template);
    }
  },
  CREATE_PHONE(state) {
    state.registerSupervisor.phones.push({});
  },
  DELETE_PHONE(state, index) {
    state.registerSupervisor.phones.splice(index, 1);
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('users', payload)
         .then(response => {
           resolve(response.data);
           ;
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    state.tableLoading = true;
    let query = prepareApiParams(payload, 'id,taxId,email,name,tenants{type,name,tenantId}');
    query['tenants{type}'] = '{' + usersTenants.TYPE_ADMIN + ', ' + usersTenants.TYPE_SUPERVISOR + '}';

    return new Promise((resolve, reject) => {
      api
        .get('users?' + new URLSearchParams(query).toString())
        .then(response => {
          commit('LIST', response.data.entities);
          resolve(response.data);
        })
        .catch(error => {
          state.tableLoading = false;
          checkError(error.response.status);
          reject(error.response);
        });
    });
  },
  read({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.get('users/' + id)
         .then(response => {
           commit('SET', response.data);
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('users/' + payload.id, payload).then(response => {
        resolve(response.data);
      }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('users/' + id)
         .then((response) => {
           resolve(response.data);
         })
         .catch((error) => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
